import React, { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { GET_WATER_PROVIDER_KPI_DESCRIPTION_BY_PROVIDER_ID_PARAMS } from "../../Components/graphql";
import { GraphQLResponse, WaterProviderKpiDescriptionEntity } from "../../Components/processors";
import { LoadingIndicator } from "../../Components/LoadingIndicator";
import { useCategoryContext, useProviderInfoPageContext } from "../../Components/Context";
import { Paragraph } from "../../Components/Paragraph";

export const ProviderCategoryDescription: React.FC<{}> = () => {
    const { category } = useCategoryContext();
    const { provider } = useProviderInfoPageContext();
    let { query, options } = GET_WATER_PROVIDER_KPI_DESCRIPTION_BY_PROVIDER_ID_PARAMS([provider?.tid]);

    const { loading, data } = useQuery<GraphQLResponse<WaterProviderKpiDescriptionEntity[]>>(query, options);

    const descriptions = useMemo(() => {
        const waterPovider = data?.result?.[0];
        if (!waterPovider) return undefined;

        const categoryDescs = waterPovider?.kpiDescription?.filter(d => d?.category?.tid === category?.tid);
        return categoryDescs?.map(d => d?.description)?.filter(d => d != null);
    }, [category, data]);

    if (loading) return <LoadingIndicator />;

    if (!descriptions) return null;

    return (
        <>
            {descriptions?.map((desc, index) => {
                return <Paragraph key={index} nid={-1} title={""} status={true} text={desc} />;
            })}
        </>
    );
};
